import * as universal from "../../../../src/routes/(app)/+layout.ts";
export { universal };
export { default as component } from "../../../../src/routes/(app)/+layout.svelte";